module.exports = __webpack_public_path__ + "static/media/portfolio16.1ac28a1f.jpg";